import Vue from "vue";
import Component from 'vue-class-component';
import { addTilesToCacheFromExtent, clearMapCache, hasCache } from '../module';
import { Esri } from '@/esriMap';
import { Config } from '@/config';
import { store } from '@/store';
import { toastHelper } from '@/helpers/ToastHelper';
import { onlineCheck } from '@/utils/onlineCheck';
import { PersistentStore } from "@/utils/PersistentStore";

@Component({})
export default class syncMap extends Vue {
  map: __esri.Map = null;
  mapview: __esri.MapView = null;
  geometryEngine: __esri.geometryEngine = null;

  async mounted() {
    this.map = await Esri.Map({ basemap: 'hybrid' } as __esri.MapProperties);
    this.mapview = await Esri.Views.MapView({
      map: this.map,
      constraints: {
        minZoom: 8
      },
      center: [12.376403, 43.104636],
      container: "syncMap"
    } as __esri.MapViewProperties);

    this.mapview.focus();

    this.geometryEngine = await Esri.Geometry.geometryEngine();
    this.mapview.watch("extent", this.extentChanged);

    const syncMapOfflineParameters: { zoom: number; extent: __esri.Extent; center: number[] } = (await PersistentStore.getKey("syncMapOfflineParameters"));
    if (syncMapOfflineParameters) {
      await this.mapview.goTo(syncMapOfflineParameters);
    }

    if (onlineCheck()) {
      await this.addTools();
    }
  }

  async addTools() {
    var searchWidget = await Esri.Widgets.Search({ view: this.mapview })
    var expand = await Esri.Widgets.Expand({ id: "search", expandIconClass: "esri-icon-search", expandTooltip: "Trova indirizzo o luogo", view: this.mapview, content: searchWidget });
    this.mapview.ui.add(expand, "top-left");

    Esri.WidgetsFactory.BasemapGallery(this.mapview, "top-left");
    Esri.WidgetsFactory.LayerList(this.mapview, "top-left");
  }

  progressTot: number = 0;
  progressActual: number = 0;

  async doSync() {
    if (onlineCheck()) {
      await clearMapCache();
      await PersistentStore.removeKey("syncMapOfflineParameters");
      let $this = this;


      const syncMapOfflineParameters: { zoom: number; extent: __esri.Extent; center: number[]} = {
        zoom: this.mapview.zoom,
        extent: this.mapview.extent.clone(),
        center: [this.mapview.center.longitude, this.mapview.center.latitude],
      };
      await PersistentStore.setKey("syncMapOfflineParameters", syncMapOfflineParameters)

      let layer = this.map.allLayers.find(i => i.type == "tile" && i.title == "World Imagery") as __esri.WebTileLayer;

      this.mapview.destroy();
      this.map.destroy();

      await addTilesToCacheFromExtent(layer, syncMapOfflineParameters.zoom, (syncMapOfflineParameters.zoom + 2), syncMapOfflineParameters.extent, (a, tot, p) => {
        $this.progressActual = a;
        $this.progressTot = tot;
      })

      var sync = await hasCache() && !!(await PersistentStore.getKey("syncMapOfflineParameters"));
      store.actions.ui.setIsSynced(sync);

      // this.$router.back();
      this.$router.push({ name: "home" });
    } else {
      toastHelper.error("Funzione disabilitata in modalità offline");
    }
  }

  cancel() {
    // this.$router.back();
    this.$router.push({ name: "home" });
  }

  canDownload: boolean = false;

  private extentChanged(n: __esri.Extent, o: __esri.Extent) {
    if (!this.geometryEngine) {
      return;
    }

    if (n.width !== o?.width) {
      const extentArea = this.geometryEngine.geodesicArea(n as any, "square-kilometers");
      this.canDownload = extentArea < Config.application.maxDownloadableAreaSize;
    }
  }
}